export const ANALYTICS_DASHBOARD_API_URL = 'ui/partner/analytics';

export const analyticsDashboardQueryKeys = {
  all: [ANALYTICS_DASHBOARD_API_URL],
  stats: [ANALYTICS_DASHBOARD_API_URL, 'stats'],
  customerCreationRate: [ANALYTICS_DASHBOARD_API_URL, 'customer_creation_rate'],
};
